import Dashboard from './views/LogBooksDashboard'
import List from './views/List'
import Receive from './views/Receive'
import Dispose from './views/Dispose'
import Form3310 from './views/Form3310'
import Form3310DetailNew from './views/Form3310DetailNew'
import LogBookDefinitions from './views/LogBookDefinitions'
import Contacts from './views/Contacts'
import CustomerForm4473Login from './views/CustomerForm4473Login'
import Form4473Clean from './views/Form4473Clean'
import UsedGunReport from './views/UsedGunReport'
import EnableFeature from './views/EnableFeature'

const LogBooksRoutes = [
    {
        path: '/logbooks',
        component: () => import(/* webpackChunkName: "logbooks-module" */ './LogBooksModule.vue'),
        children: [
            { path: '', name: 'Log Books Dashboard', component: Dashboard },
            { path: 'customer-4473', name: 'Customer Form 4473 Login', component: CustomerForm4473Login },
            { path: 'customer-4473/:ffl_log_book_form_id', name: 'Customer Form 4473 Detail', component: () => import(/* webpackChunkName: "4473-clean" */ './views/CustomerForm4473Clean.vue'), props: true  },
            { path: 'customer-4473-v2', name: 'Customer Form 4473 Detail (OMB No. 1140-0003)', component: () => import(/* webpackChunkName: "4473-new" */ './views/CustomerForm4473New.vue') },
            { path: 'customer-4473-legacy', name: 'Legacy Customer Form 4473', component: () => import(/* webpackChunkName: "4473-legacy-customer" */ './views/CustomerForm4473.vue') },
            { path: 'list', name: 'List', component: List },
            { path: 'list/:id', name: 'Detail', component: List, props: true },
            { path: 'receive', name: 'Receive', component: Receive },
    		{ path: 'receive/:id', name: 'Direct Receive', component: Receive },
            { path: 'dispose', name: 'Dispose', component: Dispose },
    		{ path: 'dispose/:id', name: 'Direct Dispose', component: Dispose, props: true },
            { path: '4473', name: '4473 Forms', component: Form4473Clean },
            { path: '4473/:ffl_log_book_form_id', name: '4473 Form Detail', component: () => import(/* webpackChunkName: "4473-list" */ './views/Form4473DetailClean.vue'), props: true },
            { path: '4473-v2', name: '4473 Forms (OMB No. 1140-0003)', component: () => import(/* webpackChunkName: "4473-detail-clean" */ './views/Form4473DetailClean.vue') },
            { path: '4473-v2/:id', name: '4473 Form Detail (OMB No. 1140-0003)', component: () => import(/* webpackChunkName: "4473-electronic" */ './views/Form4473DetailElectronic.vue'), props: true },
    		{ path: '4473/legacy/:id', name: 'Old 4473 Form', component: () => import(/* webpackChunkName: "4473-legacy" */ './views/Form4473Detail.vue'), props: true },
            { path: '3310', name: '3310 Forms', component: Form3310 },
    		{ path: '3310/:id', name: '3310 Form Detail', component: Form3310DetailNew, props: true },
            { path: '3310-legacy/:id', name: '3310 Form Legacy', component: Form3310DetailNew, props: true },
            { path: 'log-book-definitions', name: 'Log Book Definitions', component: LogBookDefinitions },
            { path: 'contacts', name: 'Logbook Contacts', component: Contacts },
    		{ path: 'contacts/:id', name: 'Logbook Contact Detail', component: Contacts, props: true },
            { path: 'used-gun-report', name: 'Used Gun Report', component: UsedGunReport },
            { path: 'firearms-transactions', name: 'Firearms Transactions', component: () => import(/* webpackChunkName: "firearms-transactions" */ './views/FirearmsTransactions.vue') },
            { path: 'enable-feature', name: 'Enable Feature', component: EnableFeature }
        ]
    }
]

export default LogBooksRoutes
